export default __webpack_public_path__ + "static/media/wide_curl_start.f82f9723.svg";